import React, { useState } from 'react';
import { Routes, Route } from 'react-router-dom';
import Hero from './components/Hero';
import Features from './components/Features';
import Footer from './components/Footer';
import RegisterModal from './components/RegisterModal';
import Navbar from './components/Navbar';
import NewsPage from './components/NewsPage';
import InstructorGuide from './components/InstructorGuide';
import './components/NewsPage.css'; // Import styles directly here or in NewsPage

import NewsPreviewSection from './components/NewsPreviewSection';

function App() {
  const [modalOpen, setModalOpen] = useState(false);
  const [userType, setUserType] = useState('student'); // 'student' or 'instructor'

  // Check for URL query param to simulate "deep link" from Instructor Guide
  React.useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get('register') === 'instructor') {
      setUserType('instructor');
      setModalOpen(true);
      // Clean URL without reload
      window.history.replaceState({}, document.title, window.location.pathname);
    }
  }, []);

  const openModal = (type) => {
    setUserType(type);
    setModalOpen(true);
  };

  const HomePage = () => (
    <>
      <Navbar onRegister={openModal} />
      <main>
        <Hero onCtaClick={openModal} />
        <Features />
        <NewsPreviewSection />
      </main>
      <Footer />
    </>
  );

  return (
    <div className="app-container">
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/noticias" element={<NewsPage />} />
        <Route path="/instrutor" element={<InstructorGuide />} />
      </Routes>

      {modalOpen && (
        <RegisterModal
          isOpen={modalOpen}
          onClose={() => setModalOpen(false)}
          initialType={userType}
        />
      )}

      <style>{`
        main {
          padding-top: 5rem;
        }
      `}</style>
    </div>
  );
}

export default App;
